import { render, staticRenderFns } from "./AccountTBList.vue?vue&type=template&id=05f05371&scoped=true&"
import script from "./AccountTBList.vue?vue&type=script&lang=js&"
export * from "./AccountTBList.vue?vue&type=script&lang=js&"
import style0 from "./AccountTBList.vue?vue&type=style&index=0&id=05f05371&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f05371",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f05371')) {
      api.createRecord('05f05371', component.options)
    } else {
      api.reload('05f05371', component.options)
    }
    module.hot.accept("./AccountTBList.vue?vue&type=template&id=05f05371&scoped=true&", function () {
      api.rerender('05f05371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accountTB/AccountTBList.vue"
export default component.exports